import React, { useState } from 'react';
import classnames from 'classnames';
import Wysiwyg from '../../../../common/components/wysiwyg';
import renderRawHtml from '../../../../common/render_raw_html';
import InfoToolTip from '../infoToolTip';
import { MainContext } from './contexts';
import ImageEditor from './imageEditor';
import TaskTemplateEditor from './taskTemplateEditor';

const ProductDescription = ({
  toolTipText, errorText, data, allowedTypes, withTaskTemplateShow, buzzbackAdmin
}) => {
  const [ showTask, setShowTask ] = useState(data.show_task);
  const [ task, setTask ] = useState(data.task);
  const [ imageData, setImageData ] = useState(data.image_data || '{}');

  const mainContextValue = { data, showTask, imageData, setImageData, allowedTypes };

  const handleChangeShowTask = (event) => {
    setShowTask(!showTask);
  };

  return (
    <MainContext.Provider value={ mainContextValue }>
      <div className={ classnames("form_section", { '-combined': showTask }) }>
        <div className="form_section">
          <input type="hidden" name="project[task]" value={ task } />
          <input type="hidden" name="project[image_data]" value={ imageData } />
          <div className="form_section-title -grid">
            <div className="form_section-title-item -grid">
              <div className="toggle">
                <input name="project[show_task]" type="hidden" value="0" autoComplete="off" />
                <input
                  id="project_show_task"
                  type="checkbox"
                  name="project[show_task]"
                  className="hide"
                  checked={ showTask }
                  value="1"
                  onChange={ handleChangeShowTask }
                />
                <label className="form-switch" htmlFor="project_show_task">
                  Product Description
                </label>
              </div>
              <h3>Product Description</h3>
            </div>
            <div className="form_section-title-item">
              <InfoToolTip
                remote
                text={ <p { ...renderRawHtml(toolTipText) } /> }
                position="bottom-right"
              />
            </div>
          </div>
          {
            showTask &&
            <div className={ classnames("form-group", { 'has-error': !!errorText }) } >
              <Wysiwyg
                toolbarClassName="wysiwyg-menu"
                editorClassName="wysiwyg-textarea"
                customPicker
                placeholder="Describe your product here..."
                value={ task }
                onChange={ setTask }
                enableIndent
              />
              <div className="form-error" { ...renderRawHtml(errorText) } />
            </div>
          }
        </div>
        { showTask && <ImageEditor /> }
        { withTaskTemplateShow && buzzbackAdmin && showTask && <TaskTemplateEditor /> }
      </div>
    </MainContext.Provider>
  );
};

export default ProductDescription;
